module.exports = __webpack_public_path__ + "static/snowball-app-stock-financial_03-f4407e12ea56a5ba713b34f795014d70.gif";